<app-breadcrumb  [master]="'Kadry'" [parentName]="'Pracownicy'"[name]="'Lista'"></app-breadcrumb>
<div class="employee-list-container"  >
  <form  (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" >

    <mat-form-field class="employee-list-filter" >
      <mat-label>Pracownik</mat-label>
      <input matInput placeholder="Jan Kowalski" name="employee" [(ngModel)]="initialFilters.employee">
    </mat-form-field>

    <mat-form-field class="employee-list-filter">
      <mat-label>Numer telefonu</mat-label>
      <input matInput placeholder="+48500200300" name="phoneNumber" [(ngModel)]="initialFilters.phoneNumber">
    </mat-form-field>

    <mat-form-field class="employee-list-filter">
      <mat-label>Email</mat-label>
      <input matInput placeholder="adres@test.pl" name="email" [(ngModel)]="initialFilters.email">
    </mat-form-field>

    <app-datepicker
      class="employee-list-filter"
      label="Data zatrudnienia od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$employmentAt" name="gte$employmentAt"
    ></app-datepicker>

    <app-datepicker
      class="employee-list-filter"
      label="Data zatrudnienia do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$employmentAt" name="lte$employmentAt"
    ></app-datepicker>

  </form>

  <div  class="employee-list-buttons">
    <button *ngIf="(userPermissions | async).human_resources.admin_root" (click)="downloadReport()" [disabled]="!(userPermissions | async).human_resources.read_report"
            mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>

  <table mat-table [dataSource]="items" multiTemplateDataRows>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>  </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/kadry/szczegoly', element.uuid]"> {{element.user.firstName }} {{element.user.lastName }}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="phone">
      <th mat-header-cell *matHeaderCellDef>  Numer telefonu  </th>
      <td mat-cell *matCellDef="let element">
        {{element.user.phone | phone}}
      </td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef>  Email  </th>
      <td mat-cell *matCellDef="let element">
        {{element.user.email}}
      </td>
    </ng-container>

    <ng-container matColumnDef="employmentAt">
      <th mat-header-cell *matHeaderCellDef>  Data zatrudnienia od  </th>
      <td mat-cell *matCellDef="let element">
        {{element?.employmentAt | date:'y-MM-dd'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="employmentTo">
      <th mat-header-cell *matHeaderCellDef>  Data zatrudnienia do </th>
      <td mat-cell *matCellDef="let element">
        {{element?.employmentTo | date:'y-MM-dd'}}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let element; let row; columns: displayedColumns;"></tr>

  </table>

  <mat-paginator  [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>

</div>
